import { gql, useLazyQuery } from "@apollo/client";
import { useEffect } from "react";

export const LIST_DIFFS = gql`
  query listDifferences(
    $environmentId: ID!
    $limit: Int!
    $cursor: String
    $name: String
    $location: DifferenceLocation
  ) {
    listDifferences(
      input: {
        environmentId: $environmentId
        limit: $limit
        cursor: $cursor
        name: $name
        location: $location
      }
    ) {
      differences {
        key
        type
        location
        conflict
        modifiedAt
      }
      diffId
      startedAt
      stoppedAt
      nextCursor
    }
  }
`;

export function useListDiffsQuery(polling: boolean = false) {
  const [
    getListDiffs,
    {
      data,
      loading: isLoadingListDiffs,
      error: errorListDiffs,
      refetch: refetchDiff
    }
  ] = useLazyQuery(LIST_DIFFS, {
    context: { clientName: "interactive" },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "network-only",
    pollInterval: polling ? 15000 : 0 // polling when computing
  });

  return {
    refetchDiff,
    getListDiffs,
    diffs: data?.listDifferences || {
      differences: [],
      diffId: null,
      startedAt: null,
      stoppedAt: null
    },
    isLoadingListDiffs,
    errorListDiffs
  };
}
